import { Skeleton, Text, VStack } from '@wegroup/design-system';
import { PartyType } from '@parties/src/types';
import { FC } from 'react';
import { useInsurancePolicyPackagesBySimulation } from '@flows/src/api/anva-flows/simulation/getInsurancePolicyPackagesBySimulation';
import { useTranslation } from 'react-i18next';
import AnvaSimulationPackage from '@flows/src/pages/flow-products/AnvaSimulationPackage';

interface Props {
  sessionId: string;
  partyId: string;
  partyType: PartyType;
  editable?: boolean;
  withDocuments?: boolean;
}

const AnvaProductPackagesOverview: FC<Props> = ({
  partyType,
  partyId,
  sessionId,
  editable,
  withDocuments,
}) => {
  const { t } = useTranslation();
  const { data, isLoading } = useInsurancePolicyPackagesBySimulation({
    partyId,
    simulationId: sessionId || '',
  });

  if (isLoading)
    return (
      <VStack align="stretch" spacing="4">
        <Skeleton w="full" h="72" opacity="0.2" />
        <Skeleton w="full" h="72" opacity="0.2" />
      </VStack>
    );

  if (!data?.items?.length) return null;

  return (
    <VStack align="stretch" spacing="4">
      <VStack align="stretch" spacing="4">
        <VStack align="stretch" spacing="1">
          <Text textStyle="h6Headline">
            {t('ADVISORY-REPORTS_CREATION-FLOW_INSURANCE-PACKAGES_TITLE')}
          </Text>
          <Text textStyle="smallBody" color="gray.500">
            {t('ADVISORY-REPORTS_CREATION-FLOW_INSURANCE-PACKAGES_DESCRIPTION')}
          </Text>
        </VStack>
        {data.items.map((data) => (
          <AnvaSimulationPackage
            key={data.id}
            pkg={data}
            sessionId={sessionId}
            partyId={partyId}
            partyType={partyType}
            editable={editable}
            withDocuments={withDocuments}
          />
        ))}
      </VStack>
    </VStack>
  );
};

export default AnvaProductPackagesOverview;
